import { useEffect, useState } from 'react';
import { getLibraryStatus } from '../lib/exerciseLibraryApi';
export function useExerciseLibraryStatus() {
  const [status, setStatus] = useState({ loading: true, enabled: false, available: false });
  useEffect(() => {
    let active = true;
    getLibraryStatus().then(value => { if (active) setStatus({ ...value, loading: false }); })
      .catch(() => { if (active) setStatus({ loading: false, enabled: false, available: false }); });
    return () => { active = false; };
  }, []);
  return status;
}
